module.exports = __webpack_public_path__ + "static/media/Travvant_Logo.291e87bf.png";